import imagesSizes from "constants/imagesSizes";
import { Story } from "chq";

export const getImageFromStory = (size: number, story: Story | undefined) => {
  if (!story) {
    return "";
  }
  if (story.media.mediaType === "video") {
    return story?.media?.thumbnail;
  }

  switch (size) {
    case imagesSizes.THUMB:
      return story?.media?.thumbnail || story?.media?.url;
    case imagesSizes.SMALL:
      return story?.media?.smallUrl || story?.media?.url;
    case imagesSizes.NORMAL:
      return story?.media?.url;
    case imagesSizes.FULL:
      return story?.media?.fullUrl || story?.media?.url;
    case imagesSizes.SHAREABLE:
      return story?.media?.shareableUrl || story?.media?.url;
    default:
      return "";
  }
};

export default getImageFromStory;
